<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
  >
    <v-card dark>
      <v-toolbar dark :color="options.color" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pa-4">
        <v-text-field
          :label="`${$t('labels.descricao')} ${$tc('labels.produto')}`"
          outlined
          dense
          class="text-caption"
          v-model="item.DESCRICAO"
          readonly
        >
        </v-text-field>
        <c-input-money
          v-model="item.valor"
          :label="$t('labels.valor')"
          dark
          dense
          outlined
          reverse
          v-bind:valueWhenIsEmpty="'0'"
          v-bind:options="{
            locale: 'pt-BR',
            prefix: '',
            suffix: componentSuffix,
            length: 11,
            precision: componentPrecision,
          }"
        />
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-btn color="primary" small @click.native="cancel">
          <v-icon small left>mdi-exit-to-app</v-icon>
          <span class="text-overline">{{ $t('labels.voltar') }}</span>
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn color="success" small @click.native="agree">
          <v-icon small left>mdi-content-save</v-icon>
          <span class="text-overline">{{ $t('labels.salvar') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {})
 * Or use await:
 * if (await this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' })) {
 *   // yes
 * }
 * else {
 *   // cancel
 * }
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open
 * }
 */

import cInputMoney from '@/components/shared/base-input/BaseInputMoney.vue'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import { flagsMixin } from '@/mixins/object/flags/FlagsMixin'
import { mapState, mapGetters } from 'vuex'

export default {
  components: { cInputMoney },
  mixins: [currencyMixin, flagsMixin],
  computed: {
    ...mapState('pdvBalcaoModule/orderModule', ['order']),
    ...mapState('authModule', ['authUser']),
    ...mapGetters({
      optionCurrencies: 'systemModule/getSystemCurrencies',
    }),
    componentSuffix() {
      if (this.authUser && this.optionCurrencies)
        return this.getCurrencyLocation(this.optionCurrencies[this.order.moeda])
      else return ''
    },
    componentPrecision() {
      if (this.authUser) return this.getCurrencyFractionDigits(this.order.moeda)
      else return 2
    },
  },
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    item: {
      DESCRICAO: '',
      valor: 0,
    },
    title: null,
    options: {
      color: 'warning',
      width: 600,
      zIndex: 800,
    },
  }),
  methods: {
    open(title, item, options) {
      this.dialog = true
      this.title = title
      this.item = item
      this.options = Object.assign(this.options, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      if (
        (!this.item.valor || this.item.valor <= 0) &&
        this.getFlagSetado('BloqueiaPrecoZeroNoOrcamento')
      ) {
        this.$toasted.error(
          this.$t('tabelas.itemBloqueado', { item: this.item.DESCRICAO1 })
        )
        return
      }

      this.resolve({ item: this.item })
      this.dialog = false
    },
    cancel() {
      this.resolve(false)
      this.dialog = false
    },
  },
}
</script>
